// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "931c74ff77d1d7512a3c0e1a6205be169a479340/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};